/**
 * Scroller — Horizontal scroll rail with snap behavior and hidden
 * scrollbars. Used for personal results carousel and subject tiles.
 *
 * Children should be flex-shrink-0 with their own fixed widths.
 */
export default function Scroller({ children, className = '', ...props }) {
  return (
    <div
      className={`flex gap-2.5 overflow-x-auto overflow-y-hidden pb-2 ${className}`}
      style={{
        scrollSnapType: 'x mandatory',
        scrollbarWidth: 'none',
        WebkitOverflowScrolling: 'touch',
        msOverflowStyle: 'none',
      }}
      {...props}
    >
      <style>{`
        .aurora-scroller::-webkit-scrollbar { display: none; }
      `}</style>
      {children}
    </div>
  )
}
